import { BybSection } from "@Components/common/byb-ds";
import BybStatsCard from "@Components/common/byb-ds/cards/byb-stats-card";
import UserProgressStats from "@Enums/UserProgressStats";
import useI18n from "@i18n";
import { Grid } from "@mui/material";

interface IStatsList {
  stats:
    | {
        activityMinutes: number;
        numberOfSessions: number;
        weeklyMinutes: number;
        targetTrainingTime: number;
      }
    | null
    | undefined;
  compact?: boolean;
}

const StatsList = ({ stats }: IStatsList) => {
  const { i18n } = useI18n();

  return (
    <BybSection title={i18n("progress.metrics.title")}>
      <Grid container spacing={2} padding={2}>
        <Grid item xs={6}>
          <BybStatsCard stat={UserProgressStats.ACTIVITY} value={stats?.activityMinutes} compact />
        </Grid>
        <Grid item xs={6}>
          <BybStatsCard stat={UserProgressStats.TRAINING} value={stats?.numberOfSessions} compact />
        </Grid>
      </Grid>
      <Grid container padding={2}>
        <Grid item xs={12}>
          <BybStatsCard stat={UserProgressStats.WEEKLY_TRAINING} value={stats?.weeklyMinutes} target={stats?.targetTrainingTime} />
        </Grid>
      </Grid>
    </BybSection>
  );
};

export default StatsList;
